<app-risk-owner-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-risk-owner-filters>
<mat-card class="u-center-text" *ngIf="!(riskOwners | async).length">
  <h4>{{'risks.Nessun Risk owner trovato' | translate}}</h4>
  <button *ngIf="canAdd" mat-raised-button (click)="addRiskOwner()">{{'shared.Aggiungi' | translate}}</button>
</mat-card>
<div class="table-container" [hidden]="!(riskOwners | async).length">
  <table mat-table matSort [dataSource]="riskOwners">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> {{'shared.ID' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        {{row.id}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> {{'shared.Nome' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        {{row.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button *ngIf="canAdd" mat-icon-button mat-raised-button color="accent"
          (click)="$event.stopPropagation();addRiskOwner()">
          <mat-icon matTooltip="{{'shared.Aggiungi' | translate}}">playlist_add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="canEdit">
          <button mat-icon-button (click)="$event.stopPropagation();editRiskOwner(row)">
            <mat-icon matTooltip="{{'shared.Modifica' | translate}}">create</mat-icon>
          </button>
        </ng-container>
        <button *ngIf="canSelect" mat-raised-button color="primary" (click)="selectRiskOwner(row)">{{'shared.Seleziona' | translate}}</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSizeOptions[0]" [length]="total | async"
    showFirstLastButtons>
  </mat-paginator>
</div>
